import React, { useEffect, useState } from 'react';
import { fetchCaseStudyData, deleteCaseStudie } from '../../../service/case-studies';
import CustomToast from '../../Toast';
import Loader from '../../layouts/loader';


const CaseStduies = () => {
    const [caseStudy, setCaseStudy] = useState({});
    const [caseStudyList, setCaseStudyList] = useState([]);
    const [search, setSearch] = useState('');
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        getCourses();
    }, []);

    const getCourses = async () => {
        setLoader(true);
        try {
            const course = await fetchCaseStudyData(search);
            if (course.status) {
                setCaseStudy(course.data);
                setCaseStudyList(course?.data?.list);
                setLoader(false);
            } else {
                console.error("Error fetching courses:", course.error);
                CustomToast.error('Error while fetching courses');
            }
        } catch (error) {
            console.error("An unexpected error occurred:", error);
            CustomToast.error('Error while fetching courses');
        } finally {
            setLoader(false);
        }
    };

    const handleSearch = (e) => {
        const value = e.target.value;
        setSearch(value); // So search gets saved
        if (value) {
            const filteredOptions = caseStudyList?.filter(option =>
                option?.title?.toLowerCase().includes(value.toLowerCase())
            );
            setCaseStudyList(filteredOptions);
        } else {
            getCourses();
        }
    };

    const handleDeleteCaseStudies = async (id) => {
         try {
            const response = await deleteCaseStudie(id);
            // Reload the template list after successful deletion
                getCourses();
            } catch (error) {
                console.error("Error deleting Case study:", error);
                CustomToast.error("Failed to delete Case study");
            }
    };

    const dateFormat = (dateString) => {
        const dateObject = new Date(dateString);
        return dateObject.toLocaleDateString('en-GB');
    };


    return (
        <div className='page__main'>
            <div className="dashboard">
                <h4 className="mb-2">Case Studies Builder</h4>
                <div className='row mb-4'>
                    <div className='col-md-4'>
                        <div className="card-box">
                            <p className='mb-0 d-flex'>
                                <div className='course_count'>{caseStudy.totalCount || 0}</div>
                                <div className="right-border"></div>
                                <div className='courses_create'>Case Studies Created</div>
                            </p>
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className="card-box">
                            <p className='mb-0 d-flex'>
                                <div className='course_count'>{caseStudy.publishedCount || 0}</div>
                                <div className="right-border"></div>
                                <div className='courses_create'>Case Studies Published</div>
                            </p>
                        </div>
                    </div>
                    <div className='col-md-4 text-end'>
                        <a href="/create-case-studies" className='btn btn-primary w-75'>Create Case Study</a>
                    </div>
                </div>
                <div className="card">
                    <div className="card-body">

                        <div className="d-flex justify-content-between align-items-center">
                            <div className='row g-3'>
                                <div className="col-auto">
                                    <label for="inputPassword6" className="col-form-label"><b>Case Studies</b></label>
                                </div>
                                <div className="col-auto">
                                    <div className="form-group has-search">
                                        <span className="form-control-feedback"><img src="/images/search.png" /></span>
                                        <input type="text" onChange={handleSearch} className="form-control" placeholder="Search Case Studies" />
                                    </div>
                                </div>
                            </div>

                            <div className="d-flex justify-content-between align-items-center mb-0">
                                <p className="d-flex justify-content-between align-items-center mb-0 mr-10"><span className='circle-status green'></span> Published</p>
                                <p className="d-flex justify-content-between align-items-center mb-0 mr-10"><span className='circle-status yellow'></span> Draft</p>
                            </div>
                        </div>

                    </div>
                </div>
                <table className="table border-table">
                    <thead className='thead-dark px-3'>
                        <tr>
                            <th className='w-25 p-3'>Sr.No</th>
                            <th className='w-25 p-3'>Title</th>
                            <th className='w-25 p-3'>Published On</th>
                            <th className='w-25 p-3'>Status</th>
                            <th className='w-25 p-3 text-center'>Action</th>
                        </tr>
                    </thead>
                    <tbody>

                        {loader ? <Loader /> :
                            caseStudy && caseStudyList?.map((item, index) => (
                                <tr key={index} >
                                    <td className='col px-3'>{index + 1}</td>
                                    <td className='col px-3'>{item?.title || '-'}</td>
                                    <td className='col px-3'>{item?.status === 'published' && item?.publish_date ? dateFormat(item?.publish_date) : '-'}</td>
                                    <td className="col px-3">
                                        {item?.status?.toLowerCase() === 'published' ? (
                                            <span style={{ color: '#4F9B94', fontWeight: 600 }}>
                                                <span style={{ fontSize: '1.2rem', marginRight: '5px' }}>●</span>
                                                Published
                                            </span>
                                        ) : (
                                            <span style={{ color: '#C4C4C4', fontWeight: 600 }}>
                                                <span style={{ fontSize: '1.2rem', marginRight: '5px' }}>✖</span>
                                                Draft
                                            </span>
                                        )}
                                    </td>

                                    <td align='right' >
                                        <div className='d-flex flex-column'>
                                            <div key={item.course_id} className="dropdown organisations" style={{ cursor: "pointer" }}>
                                                <svg fill="#000000" xmlns="http://www.w3.org/2000/svg"
                                                    width="30px" height="30px" viewBox="0 0 52 52" enable-background="new 0 0 52 52" >
                                                    <path d="M20,44c0-3.3,2.7-6,6-6s6,2.7,6,6s-2.7,6-6,6S20,47.3,20,44z M20,26c0-3.3,2.7-6,6-6s6,2.7,6,6s-2.7,6-6,6 S20,29.3,20,26z M20,8c0-3.3,2.7-6,6-6s6,2.7,6,6s-2.7,6-6,6S20,11.3,20,8z" />
                                                </svg>
                                                <div className="dropdown-menu">
                                                    <a style={{ cursor: "pointer" }} href={`/edit-case-study/${item?._id}`} className={`dropdown-item me-2`}>Edit</a>
                                                    <a style={{ cursor: "pointer" }} onClick={() => handleDeleteCaseStudies(item?._id)} className={`dropdown-item`}>Delete</a>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>))}
                    </tbody>
                </table>
                {caseStudy && caseStudy.results?.length == 0 ? (<h3 style={{ paddingLeft: "40%", paddingTop: "10%" }}>No Data Found</h3>) : null}
            </div>
        </div>
    )
}
export default CaseStduies;